<template>
  <div class="box">
    <div class="box_child">
      <div class="dis" v-if="user_type==1">
        <img src="../../assets/image/change_2.png" @click="switchs(2)" />
        <span style="padding-top: 20px">(发布职位、众包)</span>
      </div>

      <div class="dis" v-if="user_type==2">
        <img src="../../assets/image/change_1.png" @click="switchs(1)" />
        <span style="padding-top: 20px">(工作、兼职)</span>
      </div>
    </div>
  </div>
</template>

<script>
import { userswitchUser } from "@/api/user/index";
export default {
  data () {
    return {
      userInfo:{},
    };
  },
  created () {
    this.userInfo= JSON.parse(localStorage.getItem('userInfo'));

    this.user_type =  this.userInfo.user_type == 2 ? 2 : 1;

  },
  methods: {
    switchs (type) {
      var that = this;
      userswitchUser({ user_type: type }).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "切换成功",
            duration: 1500,
          });
          if(res.data!=null){
            that.$store.dispatch("changeUserType", type);
            that.$store.dispatch("Login", res.data);
            localStorage.setItem("userInfo",JSON.stringify(res.data));
            localStorage.setItem("user_type", type);
          }

         
          this.$router.push({ path: "/" });
        } else {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    height: calc(100vh - 350px);
  .box_child {
    display: flex;
    justify-content: center;
    .dis {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 200px;
      height: 250px;
    }
  }
}
</style>
